import { Component, ChangeDetectionStrategy } from '@angular/core';

import { DialogBodyComponent, DialogComponent } from '@core/user-interface-legacy';

@Component({
  template: `
    <rt-dialog-body>
      {{ name }}
      <button (click)="close()">Close</button>
    </rt-dialog-body>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DialogBodyComponent],
})
export class InputAndReturnTypeDialogComponent extends DialogComponent<
  { name: string },
  { ebe: 'ebe ebe' }
> {
  public name = this.dialogData.name;

  public close() {
    this.dialogRef.close({ ebe: 'ebe ebe' });
    // @ts-expect-error
    this.dialogRef.close({ aa: 'bb' });
  }
}
